import React, { memo } from 'react';
import { ConfirmationModal } from 'web-ui-components/lib/organisms/modals';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const HelpModal = memo(function HelpModal({ isOpen, onClose }) {
  return (
    <ConfirmationModal
      onClose={onClose}
      onConfirm={onClose}
      title={'Need a hand?'}
      confirmButtonText={`OK, got it`}
      isOpen={isOpen}
    >
      <StandardBody>
        <p>{`If you need any help with your loan application, just give us a call on 0800 707 6471.`}</p>
        <p>{`We’re here Monday to Friday, 8am to 6pm and Saturday, 9am to 1pm.`}</p>
      </StandardBody>
    </ConfirmationModal>
  );
});

export { HelpModal };
